import { fetcher } from "helpers/fetcher";

import { TGetCorpClientMemberReq, TGetCorpClientMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorpClientMember = async (
  params?: TGetCorpClientMemberReq,
  language?: string
) => {
  return await fetcher<TGetCorpClientMemberRes, TGetCorpClientMemberReq>(
    ENDPOINT.CORPORATION.GET_CORP_CLIENT_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_CORP_CLIENT_MEMBER.version,
        [API_HEADER.CORP_ID]: params?.idCorp,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetCorpClientMember = async (
  params?: TGetCorpClientMemberReq,
  language?: string
) => {
  return (await getCorpClientMember(params, language)).data;
};

queryGetCorpClientMember._key = (
  params?: TGetCorpClientMemberReq,
  language?: string,
  key?: string
) => [ENDPOINT.CORPORATION.GET_CORP_CLIENT_MEMBER.url, params, language, key];
